import Layout from '../Components/Layout';
import ContactUs from '../Components/ContactUs';

function ContactPage(props) {
    return (
        <Layout>
            <section className='common-space-both container pt-0'>
                <ContactUs/>
            </section>
        </Layout>
    );
}

export default ContactPage;